import API from "./api";
const Service = {
    get: () => {
        return new Promise((resolve, reject) => {
            API.get('themes').then(
                result => {
                    resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    update: (themes) => {
        return new Promise((resolve, reject) => {
            API.post('themes' , null, {item:themes}).then(
                result => {
                    resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    }
}
export default Service;